import { render, staticRenderFns } from "./file-parse-format-column.vue?vue&type=template&id=d6191aa4&scoped=true&"
import script from "./file-parse-format-column.vue?vue&type=script&lang=ts&"
export * from "./file-parse-format-column.vue?vue&type=script&lang=ts&"
import style0 from "./file-parse-format-column.vue?vue&type=style&index=0&id=d6191aa4&prod&lang=scss&scoped=true&"
import style1 from "./file-parse-format-column.vue?vue&type=style&index=1&id=d6191aa4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6191aa4",
  null
  
)

export default component.exports